export default "__VITE_ASSET__DOnqpxVE__ 400w, __VITE_ASSET__BP1L8xLn__ 800w, __VITE_ASSET__B53XphTY__ 1024w";